import { useGet } from '../../useApi';

export interface FeedbackSummary {
  weeks: { week: string; ratings: number; satisfaction_pct: number }[];
  by_rating: Record<string, number>;
  by_topic: Record<string, number>;
  newest_bad: { id: string; created_at: string; comment: string; topic: string | null }[];
}

// GET /admin/feedback/summary
const useFeedbackSummary = () => {
  const { data, fetch } = useGet<FeedbackSummary>('Failed to load feedback');
  return { summary: data, fetchSummary: () => fetch('api/v1/admin/feedback/summary') };
};

export default useFeedbackSummary;
